var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAttention(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.9987 14.6668C8.87435 14.668 9.74158 14.496 10.5506 14.1609C11.3596 13.8258 12.0943 13.3342 12.7127 12.7142C13.3327 12.0958 13.8244 11.361 14.1595 10.552C14.4946 9.74305 14.6665 8.87581 14.6654 8.00017C14.6665 7.12453 14.4946 6.2573 14.1594 5.44831C13.8243 4.63933 13.3327 3.90454 12.7127 3.28617C12.0943 2.66618 11.3596 2.1745 10.5506 1.8394C9.74158 1.50429 8.87435 1.33237 7.9987 1.3335C7.12306 1.33239 6.25583 1.50432 5.44685 1.83942C4.63786 2.17453 3.90307 2.66619 3.2847 3.28617C2.66473 3.90454 2.17306 4.63933 1.83796 5.44831C1.50285 6.2573 1.33092 7.12453 1.33204 8.00017C1.3309 8.87581 1.50283 9.74305 1.83793 10.552C2.17304 11.361 2.66471 12.0958 3.2847 12.7142C3.90307 13.3341 4.63786 13.8258 5.44685 14.1609C6.25583 14.496 7.12306 14.668 7.9987 14.6668V14.6668Z",
    fill: "#E41830"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 12.5C8.26522 12.5 8.51957 12.3946 8.70711 12.2071C8.89464 12.0196 9 11.7652 9 11.5C9 11.2348 8.89464 10.9804 8.70711 10.7929C8.51957 10.6054 8.26522 10.5 8 10.5C7.73478 10.5 7.48043 10.6054 7.29289 10.7929C7.10536 10.9804 7 11.2348 7 11.5C7 11.7652 7.10536 12.0196 7.29289 12.2071C7.48043 12.3946 7.73478 12.5 8 12.5V12.5Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 4.5L8 8.5Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8 4.5L8 8.5",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttention);
export default __webpack_public_path__ + "static/media/attention.d12f770d4858d00f1990f14ba2d9dd3e.svg";
export { ForwardRef as ReactComponent };